import { useState } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { TopPerformingChain } from "@apiHooks/useCategoryProfileBrandPerformance";
import dsPlaceholderLogo from "../../../../../../img/ds-placeholder-logo.svg";
import "./TopPerformingChainRow.styles.scss";

interface Props {
    chain: TopPerformingChain;
    link: string | null;
}

const TopPerformingChainRow: FCX<Props> = ({ chain, link, className }) => {
    const { rank, name, logoUrl, score } = chain;
    const [logoSrc, setLogoSrc] = useState(logoUrl || (dsPlaceholderLogo as string));

    const handleLogoError = () => setLogoSrc(dsPlaceholderLogo as string);

    return (
        <div
            className={cn("TopPerformingChainRow", className)}
            data-testid="blockTopPerformingChainRow"
        >
            <span className="TopPerformingChainRow__rank">{rank}.</span>
            <img
                className="TopPerformingChainRow__logo"
                src={logoSrc}
                onError={handleLogoError}
                alt=""
            />
            {link ? (
                <a
                    className="TopPerformingChainRow__name TopPerformingChainRow__name--link"
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={name}
                    data-testid="linkTopPerformingChainProfile"
                >
                    {name}
                </a>
            ) : (
                <span className="TopPerformingChainRow__name" title={name}>
                    {name}
                </span>
            )}
            <span className="TopPerformingChainRow__score">{Math.round(score)}%</span>
        </div>
    );
};

export default TopPerformingChainRow;
